package com.gsb.vyapar.bhagya.presentation.common.animation

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.EnterTransition
import androidx.compose.animation.ExitTransition
import androidx.compose.animation.core.tween
import androidx.compose.animation.core.spring
import androidx.compose.animation.core.Spring
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.runtime.Composable

@Composable
fun Animate(
    enter: EnterTransition =
        fadeIn(animationSpec = tween(durationMillis = 300)) +
            slideInVertically(
                initialOffsetY = { it / 4 },
                animationSpec = spring(
                    dampingRatio = Spring.DampingRatioNoBouncy,
                    stiffness = Spring.StiffnessLow
                )
            ),
    exit: ExitTransition =
        fadeOut(animationSpec = tween(durationMillis = 300)) +
            slideOutVertically(
                targetOffsetY = { it / 4 },
                animationSpec = spring(
                    dampingRatio = Spring.DampingRatioNoBouncy,
                    stiffness = Spring.StiffnessLow
                )
            ),
    content: @Composable () -> Unit
) {
    AnimatedVisibility(
        visible = true,
        enter = enter,
        exit = exit
    ) {
        content()
    }
}